import React, { useState, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useDispatch } from "react-redux";
import { reactLocalStorage } from "reactjs-localstorage";
import _ from "lodash";
import ReactExport from "react-export-excel";
import { apiErrors, handleDepartmentHeader, notify, searchNocontentFilter, setLoremIpsum } from "../../../../helper";
import { setSelectedRowForPagination } from "../../../simulation/actions/Simulation";
import { resetStatePagination } from "../../../common/Pagination/paginationAction";
import { ACC_GROUP_MASTER_EXCEL, APPROVAL_MATRIX_EXCEL } from "../../../../config/masterData";
import axiosHelper from "../../../../axiosHelper";
import { AccGroupMasterList, API, defaultPageSize, EMPTY_DATA } from "../../../../config/constants";
import LoaderCustom from "../../../common/LoaderCustom";
import PopupMsgWrapper from "../../../common/PopupMsgWrapper";
import NoContentFound from "../../../common/NoContentFound";
import { PaginationWrapper } from "../../../common/commonPagination";
import DayTime from "../../../common/DayTimeWrapper";
const gridOptions = {};
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const ApprovalListData = (props) => {
    //   const permissionAccountGroupMaster = true;

    const dispatch = useDispatch();
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [loader, setloader] = useState(true);
    const [accountGroupOnAction, setAccountGroupOnAction] = useState(null);
    const [accountGroupMasterList, setAccountGroupMasterList] = useState([]);

    const [state, setState] = useState({
        isEditFlag: false,
        isOpenVendor: false,
        shown: false,
        ID: "",
        tableData: [],
        city: [],
        country: [],
        state: [],
        showPopup: false,
        deletedId: "",
        cellData: {},
        cellValue: "",
        showPopupToggle: false,
        isViewMode: false,
        isLoader: false,
        selectedRowData: false,
        noData: false,
        dataCount: 0,
        type: "",
        render: false,
        showExtraData: false,
    });

    const getAllAccountGroupMaster = () => {
        setloader(true);
        axiosHelper
            .get(`${API.getAllAccountGroupMaster}`)
            .then((response) => {
                if (response.data?.IsSuccessful) {
                    setAccountGroupMasterList(response.data?.Data);
                    setloader(false);
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                } else {

                    throw error; // Re-throw the error to the caller
                }
            });
    };

    /**
     * @method onFloatingFilterChanged
     * @description Filter data when user type in searching input
     */
    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (props?.submissions.length !== 0) {
                setState((prevState) => ({
                    ...prevState,
                    noData: searchNocontentFilter(value, prevState.noData),
                }));
            }
        }, 500);
    };

    useEffect(() => {
        getAllAccountGroupMaster();
    }, []);

    useEffect(() => {
        reactLocalStorage.setObject("selectedRow", {});
        if (!props.stopApiCallOnCancel) {
            return () => {
                dispatch(setSelectedRowForPagination([]));
                dispatch(resetStatePagination());

                reactLocalStorage.setObject("selectedRow", {});
            };
        }
    }, []);

    const onRowSelect = () => {
        const selectedRows = state.gridApi?.getSelectedRows();
        setState((prevState) => ({
            ...prevState,
            selectedRowData: selectedRows,
            dataCount: selectedRows.length,
        }));
    };
    const onBtExport = () => {
        let tempArr = state.gridApi && state.gridApi.getSelectedRows();
        tempArr =
            tempArr && tempArr.length > 0
                ? tempArr
                : props?.submissions
                    ? props?.submissions
                    : [];
        return returnExcelColumn(APPROVAL_MATRIX_EXCEL, tempArr);
    };
    const resetState = () => {
        const searchBox = document.getElementById("filter-text-box");
        if (searchBox) {
            searchBox.value = "";
        }
        state.gridApi.setQuickFilter(null);
        state.gridApi.deselectAll();
        state.gridApi.setFilterModel(null);
        state.gridColumnApi.resetColumnState();
        setState((prevState) => ({ ...prevState, noData: false }));
    };
    const returnExcelColumn = (data = [], TempData) => {
        return (
            <ExcelSheet data={TempData} name={AccGroupMasterList}>
                {data &&
                    data.map((ele, index) => (
                        <ExcelColumn
                            key={index}
                            label={
                                ele.label === "Company Name"
                                    ? `${handleDepartmentHeader()} Name`
                                    : ele.label
                            }
                            // value={
                            //     ele.label === "Status"  // Check if the label is "Status"
                            //         ? (ele.value ? "InActive" : "Active")  // Replace true/false with InActive/Active
                            //         : ele.value
                            // }
                            value={(col) => {
                                if (ele.value === "IsDeleted") {
                                    return col[ele.value] ? "InActive" : "Active";
                                } else {
                                    return col[ele.value];
                                }
                            }}
                            style={ele.style}
                        />
                    ))}
            </ExcelSheet>
        );
    };


    const isFirstColumn = (params) => {
        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    };
    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: isFirstColumn,
    };
    const onGridReady = (params) => {
        window.screen.width >= 1600 && params.api.sizeColumnsToFit();
        setState((prevState) => ({
            ...prevState,
            gridApi: params.api,
            gridColumnApi: params.columnApi,
        }));
        params.api.paginationGoToPage(0);
    };
    const onPageSizeChanged = (newPageSize) => {
        state.gridApi.paginationSetPageSize(Number(newPageSize));
    };

    const buttonFormatter = (props) => {

        props.api.sizeColumnsToFit();
        const deletButtonShow = props?.data?.IsDeleted;

        const handleDeletePopup = () => {
            setAccountGroupOnAction(props?.data);
            setShowDeletePopup(true);
        };
        return (
            <div>

                {/* {permissionAccountGroupMaster?.Delete && ( */}
                {!deletButtonShow &&
                    <button
                        title="Delete"
                        className="Delete hl-delete-icon"
                        type="button"
                        onClick={handleDeletePopup}
                    ></button>}
                {/* )} */}
            </div>
        );
    };
    
    const statusButtonFormatter = (props) => {
        const isDeleted = props.data.IsDeleted; // Check if the row is deleted
        return (
            <span
                style={{
                    color: isDeleted ? "red" : "green", // Red if deleted, green otherwise
                    fontWeight: "bold",
                }}
            >
                {isDeleted ? "InActive" : "Active"}
            </span>
        );
    };
    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? DayTime(cell).format('DD/MM/YYYY HH:mm:ss') : '-';
    }



    const frameworkComponents = {
        totalValueRenderer: buttonFormatter,
        statusButtonFormatter: statusButtonFormatter,
        effectiveDateFormatter: effectiveDateFormatter,


    };

    const deleteAccountGroupMaster = (groupMaster) => {
        setloader(true);
        axiosHelper
            .delete(`${API.removeAccountGroupMaster}?Id=${groupMaster?.Id}`)
            .then((response) => {
                getAllAccountGroupMaster();
                setloader(false);
                if (response?.data?.IsSuccessful) {
                    notify.success(response?.data?.Data?.Message);
                }
            })
            .catch((error) => {
                setloader(false);
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage);
                }
            });
        setloader(true);
    };

    const onPopupConfirm = () => {
        setShowDeletePopup(false);
        deleteAccountGroupMaster(accountGroupOnAction);
    };
    const closePopUp = () => {
        setShowDeletePopup(false);
    };
    return (
        <>
            {loader && <LoaderCustom customClass="simulation-Loader" />}
            {showDeletePopup && (
                <PopupMsgWrapper
                    isOpen={showDeletePopup}
                    closePopUp={closePopUp}
                    confirmPopup={onPopupConfirm}
                    message={`Are you sure you want to delete this item?`}
                />
            )}


            <>
                <Row className="ag-grid-react without-filter-grid">
                    <Col>
                        <div>
                            <div
                                className={`ag-theme-material ${loader && "max-loader-height"}`}
                            >
                                <Row className={`filter-row-large`}>
                                    <Col md="12" className="mb-3 d-flex justify-content-end">
                                        <div className="d-flex justify-content-end bd-highlight w100">
                                            <>

                                                <>
                                                    <>
                                                        <ExcelFile
                                                            filename={"Audit Trail-Approval Matrix"}
                                                            fileExtension={".xls"}
                                                            element={
                                                                <button
                                                                    title={`Download ${state.dataCount === 0
                                                                        ? "All"
                                                                        : "(" + state.dataCount + ")"
                                                                        }`}
                                                                    type="button"
                                                                    className={"user-btn mr5 Tour_List_Download"}
                                                                >
                                                                    <div className="download mr-1"></div>
                                                                    {`${state.dataCount === 0
                                                                        ? "All"
                                                                        : "(" + state.dataCount + ")"
                                                                        }`}
                                                                </button>
                                                            }
                                                        >
                                                            {onBtExport()}
                                                        </ExcelFile>

                                                    </>
                                                </>
                                                <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                    <div className="refresh mr-0"></div>
                                                </button>
                                            </>
                                        </div>
                                    </Col>
                                </Row>
                                <div
                                    className={`ag-grid-wrapper height-width-wrapper ${(props?.submissions &&
                                        props?.submissions?.length <= 0) ||
                                        state.noData
                                        ? "overlay-contain"
                                        : ""
                                        }`}
                                >
                                    <div
                                        className={`ag-theme-material ${state.isLoader && "max-loader-height"
                                            }`}
                                    >
                                        {props?.submissions?.length <= 0 && (
                                            <NoContentFound
                                                title={EMPTY_DATA}
                                                customClassName="no-content-found"
                                            />
                                        )}
                                        {state.isLoader ? (
                                            <LoaderCustom customClass="loader-center" />
                                        ) : (
                                            <AgGridReact
                                                defaultColDef={defaultColDef}
                                                floatingFilter={true}
                                                domLayout="autoHeight"
                                                // columnDefs={c}
                                                rowData={
                                                    state.showExtraData && props?.submissions
                                                        ? [
                                                            ...setLoremIpsum(props?.submissions[0]),
                                                            ...props?.submissions,
                                                        ]
                                                        : props?.submissions
                                                }
                                                pagination={true}
                                                paginationPageSize={defaultPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                noRowsOverlayComponent={"customNoRowsOverlay"}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                    imagClass: "imagClass",
                                                }}
                                                rowSelection={"multiple"}
                                                suppressRowClickSelection={true}
                                                onSelectionChanged={onRowSelect}
                                                onFilterModified={onFloatingFilterChanged}
                                                frameworkComponents={frameworkComponents}
                                            >
                                                <AgGridColumn
                                                    field="FormType"
                                                    floatingFilter={true}
                                                    headerName="Form Type"
                                                />
                                                <AgGridColumn
                                                    field="Category"
                                                    floatingFilter={true}
                                                    headerName="Category"
                                                />
                                                <AgGridColumn
                                                    field="DivisionName"
                                                    floatingFilter={true}
                                                    headerName="Division"
                                                    cellRenderer={(params) => {
                                                        return params.value ? params.value : '-';
                                                    }}
                                                />
                                                <AgGridColumn
                                                    field="Plant"
                                                    floatingFilter={true}
                                                    headerName="Plant"
                                                />
                                                <AgGridColumn
                                                    field="LevelName"
                                                    floatingFilter={true}
                                                    headerName="Level Name"
                                                />
                                                <AgGridColumn
                                                    floatingFilter={true}
                                                    field="EmployeeName"
                                                    headerName="Employee Name"
                                                />
                                                <AgGridColumn
                                                    field="EmployeeCode"
                                                    floatingFilter={true}
                                                    headerName="Employee Code"
                                                />
                                                <AgGridColumn
                                                    field="AssignedDate"
                                                    headerName="Assigned Date"
                                                    filter="agDateColumnFilter"
                                                    cellRenderer={"effectiveDateFormatter"}
                                                    filterParams={{
                                                        comparator: (filterDate, cellValue) => {
                                                            const cellDate = new Date(cellValue);
                                                            const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                                                            const cellDateOnly = cellDate.setHours(0, 0, 0, 0);
                                                            if (cellDateOnly < filterDateOnly) return -1;
                                                            if (cellDateOnly > filterDateOnly) return 1;
                                                            return 0;
                                                        },
                                                        inRangeInclusive: true,
                                                        filterOptions: ["equals", "inRange"],
                                                        browserDatePicker: true,
                                                        closeOnApply: true,
                                                        minValidYear: 2000,
                                                    }}
                                                />
                                                <AgGridColumn
                                                    field="RemovedDate"
                                                    headerName="Removed Date"
                                                    filter="agDateColumnFilter"
                                                    cellRenderer={"effectiveDateFormatter"}
                                                    filterParams={{
                                                        comparator: (filterDate, cellValue) => {
                                                            const cellDate = new Date(cellValue);
                                                            const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                                                            const cellDateOnly = cellDate.setHours(0, 0, 0, 0);
                                                            if (cellDateOnly < filterDateOnly) return -1;
                                                            if (cellDateOnly > filterDateOnly) return 1;
                                                            return 0;
                                                        },
                                                        inRangeInclusive: true,
                                                        filterOptions: ["equals", "inRange"],
                                                        browserDatePicker: true,
                                                        closeOnApply: true,
                                                        minValidYear: 2000,
                                                    }}
                                                />
                                                <AgGridColumn
                                                    field="ChangedBy"
                                                    floatingFilter={true}
                                                    headerName="Changed By"
                                                />
                                                 <AgGridColumn
                                                    field="ModifiedDate"
                                                    filter="agDateColumnFilter"
                                                    cellRenderer={"effectiveDateFormatter"}
                                                    filterParams={{
                                                        comparator: (filterDate, cellValue) => {
                                                            const cellDate = new Date(cellValue);
                                                            const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                                                            const cellDateOnly = cellDate.setHours(0, 0, 0, 0);
                                                            if (cellDateOnly < filterDateOnly) return -1;
                                                            if (cellDateOnly > filterDateOnly) return 1;
                                                            return 0;
                                                        },
                                                        inRangeInclusive: true,
                                                        filterOptions: ["equals", "inRange"],
                                                        browserDatePicker: true,
                                                        closeOnApply: true,
                                                        minValidYear: 2000,
                                                    }}
                                                    headerName="Last Modified Date"
                                                />
                                               
                                                <AgGridColumn
                                                    width="150"
                                                    field="IsDeleted"
                                                    headerName="Status"
                                                    floatingFilter={true}
                                                    valueGetter={(params) => params.data.IsDeleted ? 'InActive' : 'Active'}
                                                    cellRenderer={"statusButtonFormatter"}
                                                />

                                            </AgGridReact>
                                        )}
                                        {
                                            <PaginationWrapper
                                                gridApi={state.gridApi}
                                                setPage={onPageSizeChanged}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </>

        </>
    );
};

export default ApprovalListData;
